import { DialogComponent } from '@theme/dialog';
import { CartAddEvent, CartUpdateEvent } from '@theme/events';
import { ThemeEvents } from '@theme/events';

// ============================================================
// HELPER — dispatch a CartUpdateEvent with the real cart count
// ============================================================

async function dispatchCartUpdate() {
  try {
    const cart = await fetch('/cart.js').then(r => r.json());
    console.log('[CartBubble] 🛒 item_count from cart:', cart.item_count);

    const event = new CustomEvent(ThemeEvents.cartUpdate, {
      bubbles: true,
      detail: {
        data: {
          itemCount: cart.item_count,
          source: 'free-gift',
        }
      }
    });

    console.log('[CartBubble] 📣 Dispatching event on:', ThemeEvents.cartUpdate);
    console.log('[CartBubble] 📣 event.detail:', event.detail);
    document.dispatchEvent(event);
    console.log('[CartBubble] ✅ Dispatched.');
  } catch (err) {
    console.error('[CartBubble] ❌ Error:', err);
  }
}

/**
 * A custom element that manages a cart drawer.
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);

    const dialog = this.querySelector('dialog, .dialog-modal');
    if (dialog) {
      dialog.addEventListener('close', () => {
        document.body.classList.remove('moved_the_elements');
      });
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
      document.body.classList.add('moved_the_elements');
    }

    syncFreeGift();
    updateBundleSteps();
    syncConditionalProduct(); // 👈 runs on every cart add
  };

  open() {
    this.showDialog();
    document.body.classList.add('moved_the_elements');

    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
    document.body.classList.remove('moved_the_elements');
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}

// ✅ Handle alternate cart trigger buttons
document.addEventListener('DOMContentLoaded', () => {
  const altCartBtn = document.querySelector('#open-cart-drawer-alt');
  const altCartBtn3 = document.querySelector('#open-cart-drawer-alt3');
  const altCartBtn2 = document.querySelector('#cart-toast');
  const cartDrawer = document.querySelector('cart-drawer-component');

  if (altCartBtn && cartDrawer) {
    altCartBtn.addEventListener('click', () => cartDrawer.open());
  }
  if (altCartBtn2 && cartDrawer) {
    altCartBtn2.addEventListener('click', () => cartDrawer.open());
  }
  if (altCartBtn3 && cartDrawer) {
     
    altCartBtn3.addEventListener('click', () => cartDrawer.open());
  }
  // Open cart drawer if URL contains ?viewcart=true
if (new URLSearchParams(window.location.search).get('viewcart') === 'true') {
  cartDrawer.open();
}
});

// ============================================================
// BUNDLE STEPS UI
// ============================================================

const GIFT_PRODUCT_IDS = [14871732486526, 15673775489406];

function updateBundleSteps() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      let nonGiftCount = 0;
      cart.items.forEach(item => {
        const isGift = GIFT_PRODUCT_IDS.includes(item.product_id);
        console.log(`📦 "${item.title}" | product_id: ${item.product_id} | isGift: ${isGift} | qty: ${item.quantity}`);
        if (!isGift) nonGiftCount += item.quantity;
      });

      console.log('🔢 nonGiftCount:', nonGiftCount);
      applyBundleSteps(nonGiftCount);
    })
    .catch(err => console.error('❌ updateBundleSteps error:', err));
}

function applyBundleSteps(nonGiftCount) {
  console.log('🔢 Applying nonGiftCount:', nonGiftCount);
     
  // ... all your existing step1, step2, stepGift, congrats code stays untouched ...

  // ============================================================
  // BUNDLE FLEX LINK — override href behaviour
  // ============================================================
   


  const step1 = document.querySelector('.step-btn.step-1');
  if (step1) {
    const active = nonGiftCount >= 1;
    step1.classList.toggle('active', active);
    const textNode = [...step1.childNodes].reverse().find(n => n.nodeType === Node.TEXT_NODE);
    if (textNode) textNode.textContent = active
      ? ` ${step1.dataset.after} `
      : ` ${step1.dataset.before} `;
    const img = step1.querySelector('.icon img');
    if (img) img.src = active ? step1.dataset.image_after : step1.dataset.image_before;
  }

  const step2 = document.querySelector('.step-btn.step-2');
  if (step2) {
    const active = nonGiftCount >= 2;
    step2.classList.toggle('active', active);
    const textNode = [...step2.childNodes].reverse().find(n => n.nodeType === Node.TEXT_NODE);
    if (textNode) textNode.textContent = active
      ? ` ${step2.dataset.after} `
      : ` ${step2.dataset.before} `;
    const img = step2.querySelector('.icon img');
    if (img) img.src = active ? step2.dataset.image_after : step2.dataset.image_before;
  }

  const stepGift = document.querySelector('.bundle-wrapper .step-btn:not(.step-1):not(.step-2)');
  if (stepGift) {
    stepGift.classList.toggle('active', nonGiftCount >= 2);
    stepGift.classList.toggle('disabled', nonGiftCount < 2);
  }

  const bundleFlex = document.querySelector('.bundle-flex');
  if (bundleFlex) {
    let congrats = bundleFlex.querySelector('.congrats');
    if (nonGiftCount >= 2) {
      if (!congrats) {
        congrats = document.createElement('div');
        congrats.className = 'congrats';
        congrats.textContent = 'Congrats! Your free gift is now in your bag < 3';
        bundleFlex.appendChild(congrats);
      }
    } else {
      congrats?.remove();
    }
  }
}

// ============================================================
// FREE GIFT AUTO-ADD / AUTO-REMOVE
// ============================================================

async function fetchCollectionProductIds(parentCollectionHandle) {
  let productIds = [];
  let page = 1;
  let hasMore = true;

  while (hasMore) {
    const res = await fetch(
      `/collections/${parentCollectionHandle}/products.json?limit=250&page=${page}`
    );
    const data = await res.json();
    const ids = data.products.map((p) => p.id);
    productIds = productIds.concat(ids);
    hasMore = ids.length === 250;
    page++;
  }

  return new Set(productIds);
}

async function syncFreeGift() {
  const config = window.FreeGiftConfig;

  if (!config?.giftVariantId || !config?.minimumQuantity || !config?.parentCollectionHandle) {
    console.warn('[FreeGift] Missing config — skipping free gift logic.');
    return;
  }

  const { giftVariantId, giftProductId, minimumQuantity, parentCollectionHandle } = config;

  const cartItemsComponents = document.querySelectorAll('cart-items-component');
  const sectionIds = [];
  cartItemsComponents.forEach((item) => {
    if (item instanceof HTMLElement && item.dataset.sectionId) {
      sectionIds.push(item.dataset.sectionId);
    }
  });

  try {
    const [cartRes, collectionProductIds] = await Promise.all([
      fetch('/cart.js').then((r) => r.json()),
      fetchCollectionProductIds(parentCollectionHandle),
    ]);

    let qualifyingQty = 0;
    let giftLineKey = null;
    let giftQtyInCart = 0;

    cartRes.items.forEach((item) => {
      const isGift = item.product_id === giftProductId;

      if (isGift) {
        giftLineKey = item.key;
        giftQtyInCart = item.quantity;
      } else if (collectionProductIds.has(item.product_id)) {
        qualifyingQty += item.quantity;
      }
    });

    const qualifies = qualifyingQty >= minimumQuantity;
    console.log('[FreeGift] qualifyingQty:', qualifyingQty, '| minimumQuantity:', minimumQuantity, '| qualifies:', qualifies);
    console.log('[FreeGift] giftQtyInCart:', giftQtyInCart, '| giftLineKey:', giftLineKey);

    if (qualifies && giftQtyInCart === 0) {
      const addRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: giftVariantId, quantity: 1 }],
          sections: sectionIds.join(','),
        }),
      });
      const addData = await addRes.json();
      console.log('[FreeGift] ✅ Gift added to cart.');

      document.dispatchEvent(
        new CartAddEvent({}, String(giftVariantId), {
          source: 'free-gift',
          itemCount: 1,
          sections: addData.sections,
        })
      );

      console.log('[CartBubble] 🎁 Gift was added — calling dispatchCartUpdate...');
      await dispatchCartUpdate();
      updateBundleSteps();

    } else if (!qualifies && giftLineKey) {
      const changeRes = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: giftLineKey,
          quantity: 0,
          sections: sectionIds.join(','),
        }),
      });
      const changeData = await changeRes.json();
      console.log('[FreeGift] ❌ Gift removed from cart.');

      document.dispatchEvent(
        new CartAddEvent({}, String(giftVariantId), {
          source: 'free-gift',
          itemCount: 0,
          sections: changeData.sections,
        })
      );

      console.log('[CartBubble] 🗑️ Gift was removed — calling dispatchCartUpdate...');
      await dispatchCartUpdate();
      updateBundleSteps();
    } else {
      console.log('[CartBubble] ℹ️ No gift change needed — skipping dispatchCartUpdate.');
    }

  } catch (err) {
    console.error('[FreeGift] Error syncing free gift:', err);
  }
}

// ✅ Run both on page load
document.addEventListener('DOMContentLoaded', () => {
  syncFreeGift();
  updateBundleSteps();
});

// ============================================================
// AUTO-REMOVE SPECIFIC PRODUCT (ID: 15815030407550)
// Removes this product if fewer than 2 non-gift items are in cart
// ============================================================

const CONDITIONAL_REMOVE_PRODUCT_ID = 15815030407550;

async function syncConditionalProduct() {
  try {
    const cart = await fetch('/cart.js').then(r => r.json());

    let nonGiftCount = 0;
    let targetLineKey = null;

    cart.items.forEach(item => {
      const isGift = GIFT_PRODUCT_IDS.includes(item.product_id);

      if (item.product_id === CONDITIONAL_REMOVE_PRODUCT_ID) {
        targetLineKey = item.key;
      }

      if (!isGift && item.product_id !== CONDITIONAL_REMOVE_PRODUCT_ID) {
        nonGiftCount += item.quantity;
      }
    });

    console.log('[ConditionalRemove] nonGiftCount (excl. target):', nonGiftCount);
    console.log('[ConditionalRemove] targetLineKey:', targetLineKey);

    // Only remove if: target product IS in cart AND fewer than 2 other non-gift items
    if (targetLineKey && nonGiftCount < 2) {
      const cartItemsComponents = document.querySelectorAll('cart-items-component');
      const sectionIds = [];
      cartItemsComponents.forEach(item => {
        if (item instanceof HTMLElement && item.dataset.sectionId) {
          sectionIds.push(item.dataset.sectionId);
        }
      });

      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: targetLineKey,
          quantity: 0,
          sections: sectionIds.join(','),
        }),
      });

      console.log('[ConditionalRemove] ✅ Product 15815030407550 removed from cart.');
      await dispatchCartUpdate();
      updateBundleSteps();
    } else {
      console.log('[ConditionalRemove] ℹ️ No removal needed.');
    }

  } catch (err) {
    console.error('[ConditionalRemove] ❌ Error:', err);
  }
}

// ✅ Run on page load
document.addEventListener('DOMContentLoaded', () => {
  syncConditionalProduct();
});